import { render, staticRenderFns } from "./CategoriesSection.vue?vue&type=template&id=914c5ed0&"
import script from "./CategoriesSection.vue?vue&type=script&lang=js&"
export * from "./CategoriesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports